import { ArcElement, Chart as ChartJS, ChartOptions, Legend, Tooltip } from 'chart.js';
import React, { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

import { useGetTimeZoneChartQuery } from '../../../../app/services/chatbot-rtk.services';
import LoadingComponent from '../../../common/loading/loading.component';

ChartJS.register(ArcElement, Tooltip, Legend);

// Register required elements and components for Chart.js
ChartJS.register(ArcElement, Tooltip, Legend);

interface ChartProps {
  from: string;
  to: string;
  botId: string;
}

const TimeZoneChart: React.FC<ChartProps> = ({ from, to, botId }) => {
  const { t, i18n } = useTranslation();
  const { data, error, isLoading, isFetching } = useGetTimeZoneChartQuery({
    from,
    to,
    bot_id: botId,
  });
  const [chartData, setChartData] = useState<any>(null);
  const [count, setCount] = useState(0);

  // Explicitly type the options
  const options: ChartOptions<'doughnut'> = {
    responsive: true,

    plugins: {
      legend: {
        position: 'bottom', // Use allowed position values
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 14,
          },
        },
      },
    },
    maintainAspectRatio: true, // Maintain width control
    aspectRatio: 1, // Keeps width proportional (1:1 means square)
    cutout: '70%',
  };

  useEffect(() => {
    setCount(0);
    setChartData(null);
    if (data && data.length > 0) {
      setCount(data.map((dr: any) => dr.category).length);
      setChartData({
        labels: data.map((dr: any) => dr.category),
        datasets: [
          {
            label: 'Time Zones',
            data: data.map((dr: any) => +dr.count),
            backgroundColor: [
              '#3c85ff', // France (blue)
              '#ff66c4', // USA (pink)
              '#ffa300', // UK (orange)
              '#15c392', // Netherland (green)
              '#00c6ff', // Canada (cyan)
              '#ff8900', // Other (orange)
            ],
          },
        ],
      });
    }
  }, [data, isFetching]);

  if (isLoading) return <LoadingComponent />;
  if (error) return <LoadingComponent />;
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center">
      <div className="tw-text-gray-800 tw-text-base tw-font-semibold tw-font-['Lexend'] tw-uppercase">{t('Charts/TimeZones/title')}</div>
      {count !== 0 ? (
        <div className="tw-text-gray-800 tw-text-3xl tw-font-medium tw-font-['Lexend']">{count}</div>
      ) : (
        <div className="tw-text-gray-400 tw-text-xl tw-font-medium tw-font-['Lexend']">{t('Charts/NoData')}</div>
      )}
      <div className="tw-text-gray-800 tw-text-base tw-font-normal tw-font-['Lexend']">{`${count !== 0 ? t('Charts/TimeZones/description') : ''}`}</div>
      {chartData && count !== 0 && (
        <div className="tw-max-h-[300px] tw-w-full tw-flex tw-items-center tw-justify-center tw-mt-6">
          <Doughnut data={chartData} options={options} />
        </div>
      )}
    </div>
  );
};

export default TimeZoneChart;
